import React from 'react';
import NemCtrl from './NemCtrl.js';
import FlatButton from 'material-ui/FlatButton';
import FontAwesome from 'react-fontawesome';

const constants = {
  colorHover: '#EC646D',
  colorRed: '#d62631',
  colorWhite: '#ffffff',
  colorGray: '#dedede',
  colorDark: '#777777',
  colorBlack: '#000000',
};

export default class RothButton extends NemCtrl {
  style = {
    default: {
      fontFamily: "'Molengo', sans-serif",
      display: 'block',
      margin: '10px',
      borderRadius: '16px',
      fontWeight: '100',
      fontSize: '26px',
      lineHeight: '20px',
      overflow: 'hidden',
      padding: '6px 22px',
      zIndex: '0',
    },
    white: {
      width: '100%',
      border: '2px solid black',
      backgroundColor: 'white',
      color: 'gray',
      margin: '10px 0px',
    },
    wide: {
      margin: '50px 0px 10px 0px',
      width: '60%',
      fontWeight: '400',
      //      maxWidth: "360px",
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '8px 0px',
      lineHeight: '20px',
      borderRadius: '22px',
      whiteSpace: 'nowrap',
    },
    half: {
      margin: '50px 2.5% 10px 2.5%',
      width: '36%',
      display: 'inline-block',
      fontWeight: '400',
      //      maxWidth: "360px",
      padding: '0px',
      height: '48px',
      borderRadius: '22px',
      whiteSpace: 'nowrap',
    },
    halfWhite: {
      margin: '50px 2.5% 10px 2.5%',
      width: '36%',
      display: 'inline-block',
      fontWeight: '400',
      //      maxWidth: "360px",
      padding: '0px',
      height: '48px',
      borderRadius: '22px',
      whiteSpace: 'nowrap',
      backgroundColor: 'white',
      color: 'black',
    },
    text: {
      display: 'inline',
      margin: '0px',
      color: constants.colorBlack,
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '18px',
      height: 'none',
      padding: '0px',
      borderRadius: 'none',
    },
    awesome: {
      color: constants.colorDark,
      cursor: 'pointer',
    },
    back: {
      display: 'inline',
      color: constants.colorRed,
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '18px',
      height: 'none',
      padding: '0px',
      margin: '0px 22px',
      borderRadius: 'none',
    },
  };
  labelStyle = {
    default: {
      fontSize: '16px',
      textTransform: 'none',
      fontWeight: '100',
    },
    big: {
      fontSize: '18px',
      textTransform: 'none',
      fontWeight: '100',
    },
  };
  render = () => {
    if ('type' in this.props && (this.props.type === 'text' || this.props.type === 'back' || this.props.type === 'awesome')) {
      return (
        <span
          className="button"
          style={Object.assign(
            {},
            this.getStyle(),
            this.props.nega ? { color: constants.colorWhite } : {},
            this.props.disabled ? { opacity: 0.3, cursor: 'default' } : {}
          )}
          onClick={this.props.disabled ? undefined : this.handleChange}
        >
          {this.props.type === 'awesome' ? <FontAwesome name={this.props.children} /> : this.props.children}
        </span>
      );
    }
    return (
      <FlatButton
        disabled={this.props.disabled}
        secondary={true}
        hoverColor={constants.colorHover}
        labelStyle={'type' in this.props ? this.labelStyle.big : this.labelStyle.default}
        style={Object.assign(
          {},
          this.getStyle(),
          this.props.disabled ? { opacity: 0.5, cursor: 'default', backgroundColor: 'gray', color: 'black' } : {}
        )}
        onClick={this.handleChange}
        label={this.props.children}
      />
    );
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/RothButton.js
 **/